import { render, staticRenderFns } from "./LoadInfo.vue?vue&type=template&id=8483acfe&"
import script from "./LoadInfo.vue?vue&type=script&lang=js&"
export * from "./LoadInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports